module.exports = __webpack_public_path__ + "img/exchange_grey.a6a404b9.png";